export default __webpack_public_path__ + "static/media/white-x-icon.5ecd3d5f.svg";